// extracted by mini-css-extract-plugin
export default {"gridContainer":"eplKC__gridContainer","gridRow":"oz8Lw__gridRow","fillColumn":"JfRqv__fillColumn","subText":"NvkPf__subText"};